var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('button')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }